import { environment, environmentConfig } from "./environment";

export function getConfig(): Promise<environmentConfig> {
  return fetch('./environments/config.json')
    .then((resp) => resp.json())
    .then((resp) => {

      Object.assign(environment, resp);

      return environment;
    });
}
